import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatLongText', standalone: true })
export class FormatLongTextPipe implements PipeTransform {
  transform(value: string, length: number): string {
    if (!value) {
      return '';
    }
    value = value.toString();

    return value.length <= length ? value : value.substring(0, length) + '...';
  }
}
